<template>
  <el-popover v-model="isShowSelect" class="selectTree" popper-class="selectTree-tree" placement="bottom-start" :disabled="disabled" style="min-width:200px;" trigger="click" @hide="popoverHide">
    <el-input v-if="query" v-model="qry" size="mini" :placeholder="queryPlaceholder" :clearable="true" @input="filterText(qry)">
      <el-button slot="append" icon="el-icon-search" @click="filterText(qry)" />
    </el-input>
    <el-tree
      v-if="isShowSelect"
      ref="tree"
      style="max-height:270px;overflow: auto;"
      :data="treeData"
      :check-strictly="true"
      :node-key="nodeKey"
      :show-checkbox="multiple"
      :expand-on-click-node="multiple"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      :default-expand-all="defaultExpandAll"
      :filter-node-method="filterNode"
      highlight-current
      :props="props"
      @node-click="handleNodeClick"
      @check="getKeys"
    >
      <span slot-scope="{ node, data }" :class="{disabled:data.disabled}">{{ node.label }}</span>
    </el-tree>
    <el-select
      slot="reference"
      ref="select"
      v-model="multiple?key:skey"
      style="width:100%"
      :size="size"
      :clearable="true"
      :multiple="multiple"
      :placeholder="placeholder"
      :disabled="disabled"
      @remove-tag="removeTag"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </el-popover>
</template>
<script>

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    treeData: { type: Array, required: true },
    defaultExpandAll: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popoverHide: {
      type: Function,
      default: function() { }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: [String, Array, Number],
    nodeKey: { type: String, default: 'id' },
    placeholder: { type: String, default: '请选择' },
    query: {
      type: Boolean,
      default: false
    },
    queryPlaceholder: { type: String, default: '请输入内容查询' },
    props: {
      type: Object,
      required: false,
      default: () => ({
        children: 'children',
        label: 'label'
      })
    }
  },
  data() {
    return {
      // 是否显示树状选择器
      isShowSelect: false,
      options: [],
      key: [],
      skey: '',
      showValueTmp: null,
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      qry: ''
    }
  },
  watch: {
    isShowSelect(val) {
      // 隐藏select自带的下拉框
      this.$refs.select.blur()
      if (val) {
        // 下拉面板展开-选中节点-展开节点
        this.setTreeCheckNode(this.key)
        this.defaultCheckedKeys = this.key
        if (this.multiple) {
          this.defaultExpandedKeys = this.key
        } else {
          if (this.skey != undefined && this.skey != null) {
            this.defaultExpandedKeys = [this.skey]
          }
        }
        this.qry = ''
      }
    },
    key(val) {
      this.$emit('change', this.key)
    },
    skey(val) {
      if (this.skey != this.value) {
        this.$emit('change', this.skey)
      }
    },
    treeData() {
      if (this.multiple) {
        if (Array.isArray(this.value)) {
          this.key = this.value
        } else {
          this.key.push(this.value)
        }
        this.setTreeCheckNode(this.key)
      } else {
        this.skey = this.value
        this.setTreeCheckNode(this.skey)
      }
    },
    value() {
      this.setValue()
    }
  },
  mounted() {
    this.setValue()
  },
  methods: {
    handleNodeClick(data) {
      const iNode = this.$refs.tree.getNode(data)
      if (!iNode.disabled) {
        if (!this.multiple) {
          const tmpMap = {}
          tmpMap.value = iNode.key
          tmpMap.label = iNode.label
          this.options = [tmpMap]
          this.$nextTick(function(){
            this.skey = iNode.key
          })
          this.isShowSelect = !this.isShowSelect
          
        }
      }
    },
    getKeys(data, checked) {
      const tmp = []
      checked.checkedNodes.forEach(node => {
        const iNode = this.$refs.tree.getNode(node)
        const tmpMap = {}
        tmpMap.value = iNode.key
        tmpMap.label = iNode.label
        tmp.push(tmpMap)
      })
      this.options = tmp
      this.key = checked.checkedKeys
    },
    setTreeCheckNode(ids) {
      const tmp = []
      if (Array.isArray(ids)) {
        ids.forEach(id => {
          this.showValueTmp = null
          this.findTreeNode(this.treeData, id)
          if (this.showValueTmp) {
            tmp.push(this.showValueTmp)
          }
        })
      } else {
        this.showValueTmp = null
        this.findTreeNode(this.treeData, ids)
        if (this.showValueTmp) {
          tmp.push(this.showValueTmp)
        }
      }
      this.options = tmp
    },
    // 递归查询树形节点
    findTreeNode(tree, id) {
      if ((tree !== null && tree != undefined) && (id !== null && id != undefined)) {
        for (var i = 0; i < tree.length; i++) {
          if (tree[i].id == id) {
            const tmpMap = {}
            tmpMap.value = tree[i].id
            tmpMap.label = tree[i][this.props.label]
            this.showValueTmp = tmpMap
            return
          } else if (tree[i].children != null && tree[i].children.length > 0) {
            this.findTreeNode(tree[i].children, id)
          }
        }
      }
    },

    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    removeTag(val) {
      if (this.$refs.tree) {
        this.$refs.tree.setChecked(val, false)
      }
      const fi = this.key.findIndex((value) => {
        return value === val
      })
      this.key.splice(fi, 1)
    },
    openOrClose() {
      console.log('1')
      this.isShowSelect = !this.isShowSelect
    },
    close(){
      this.isShowSelect=false;
    },
    setValue() {
      // 把传进来的参数转成数组处理
      if (this.multiple) {
        if (Array.isArray(this.value)) {
          this.key = this.value
        } else {
          this.key.push(this.value)
        }
        this.setTreeCheckNode(this.key)
      } else {
        this.skey = this.value
        this.setTreeCheckNode(this.skey)
      }
    },
    getValueObj(){
      return this.options
    }
  }
}
</script>

<style lang="scss">
@import '../theme-variables.scss';
.selectTree-tree{
  .disabled{
    color:$--color-text-placeholder
  }
}
.selectTree{
  display: inline-block;
}
</style>
